import React, { useRef } from 'react'
import { Button, Card, Carousel, Col, Image, Modal, OverlayTrigger, Popover, Row, Tooltip } from 'react-bootstrap'
import PrimaryButton from '../../jsx/components/button/primaryButton'
import profileAv from '../../icons/photos/profileAvatar.png';
import { getDocuments } from '../../service/api/professional/getDocuments';
import { uploadDocuments } from '../../service/api/professional/uploadDocuments';
import { getCountryCode } from '../../service/api/countryCode/countryCode';
import { getStateByCountryId } from '../../service/api/countryCode/getStateByCountryId';



import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectInputCountry from '../../jsx/components/fields/selectInputCountry';
import SelectInputState from '../../jsx/components/fields/selectInputState';
import ResponceToaster from '../../jsx/components/responceToaster/responceToaster';
import ResponceForAPI from '../../component/backDrop/responcesForAPI';
import { btnChoose, btnDocuments } from '../../dataBaseFile/alert';
import { pleaseUploadDoc } from '../../dataBaseFile/error';
import { lblAddress, txtInsurance, txtLicenceOne, txtLicenceThree, txtLicenceTwo, txtUploadedDocuments } from '../../dataBaseFile/label';
import deleteDocumentById from '../../service/api/professional/deleteDocumentById';
import { uploadDocumentApi } from '../../service/api/professional/uploadDocument';

import proLicense from '../../media/images/proDashboardAssets/proLicense.png'
import proCerificate from '../../media/images/proDashboardAssets/proCerificate.png'
import proInsurance from '../../media/images/proDashboardAssets/proInsurance.png'
import InputField from '../../jsx/components/fields/inputField';
import { setDocumentsModalTriggerRedux } from '../../feature/userData/userData';

// import { pdfjs, Document, Page } from 'react-pdf';

// // Import PDF.js worker as a script to avoid webpack bundler issues
// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


const UploadDocumentsCopy = ({ adminTrigger = false }) => {
    // Documents Upload for the professionals ------------>
        const { documentsModalTriggerRedux } = useSelector((state) => state.user);
    const { countryCodeArr } = useSelector((state) => state.country);
    const dispatch = useDispatch();

    // Sates for Document upload for the professionals 
    const [licenceDoc0, setLicenceDoc0] = useState(null);
    const [licenceDocImgPre0, setLicenceDocImgPre0] = useState();
    const [licenceDocPdfCheckPre, setLicenceDocPdfCheckPre] = useState();
    const [licenceDocCountry0, setLicenceDocCountry0] = useState("");
    const [licenceDocState0, setLicenceDocState0] = useState("");

    const [licenceDoc1, setLicenceDoc1] = useState(null);
    const [licenceDocImgPre1, setLicenceDocImgPre1] = useState();
    const [licenceDocCountry1, setLicenceDocCountry1] = useState("");
    const [licenceDocState1, setLicenceDocState1] = useState("");

    const [licenceDoc2, setLicenceDoc2] = useState(null);
    const [licenceDocImgPre2, setLicenceDocImgPre2] = useState();
    const [licenceDocCountry2, setLicenceDocCountry2] = useState("");
    const [licenceDocState2, setLicenceDocState2] = useState("");

    const [addressDoc, setAddressDoc] = useState(null);
    const [addressDocImgPre, setAddressDocImgPre] = useState();
    const [addressDocPdfCheckPre, setAddressDocPdfCheckPre] = useState();

    const [insurenceDoc, setInsurenceDoc] = useState(null);
    const [insurenceDocImgPre, setInsurenceDocImgPre] = useState();
    const [insurenceDocPdfCheckPre, setInsurenceDocPdfCheckPre] = useState();

    const [licenceDocID0, setLicenceDocID0] = useState('');
    const [licenceDocID1, setLicenceDocID1] = useState('');
    const [licenceDocID2, setLicenceDocID2] = useState('');
    const [addressDocID, setAddressDocID] = useState('');
    const [insurenceDocID, setInsurenceDocID] = useState('');

    // console.log("licenceDocID0 ID here", licenceDocID0,"licenceDocID1 ID here", licenceDocID1,"licenceDocID2 ID here", licenceDocID2,"addressDocID ID here", addressDocID,"insurenceDocID ID here", insurenceDocID); 

    const [documentsDetails, setDocumentsDetails] = useState();
    const [documentsDetailsLength, setDocumentsDetailsLength] = useState();
    const [uploadedLicence0, setUploadedLicence0] = useState();
    const [uploadedLicence0State, setUploadedLicence0State] = useState("");
    const [uploadedLicence0Country, setUploadedLicence0Country] = useState("");

    const [uploadedLicence1, setUploadedLicence1] = useState();
    const [uploadedLicence1State, setUploadedLicence1State] = useState("");
    const [uploadedLicence1Country, setUploadedLicence1Country] = useState("");

    const [uploadedLicence2, setUploadedLicence2] = useState();
    const [uploadedLicence2State, setUploadedLicence2State] = useState("");
    const [uploadedLicence2Country, setUploadedLicence2Country] = useState("");

    const [uploadedAddress, setUploadedAddress] = useState();
    const [uploadedInsurence, setUploadedInsurence] = useState();

    const [isSuccessButtonDoc, setIsSuccessButtonDoc] = useState(false);
    const [isErrorButtonDoc, setIsErrorButtonDoc] = useState(false);
    const [staticButtonDoc, setStaticButtonDoc] = useState(true);

    const [responceMsg, setResponceMsg] = useState("");
    const [updateDocumentsLoading, setUpdateDocumentsLoading] = useState(false);
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);

    const [apiResponce, setApiResponse] = useState(false);

    const [documentsModalTrigger, setDocumentsModalTrigger] = useState(documentsModalTriggerRedux);

    const [tabsToggleDocuments, setTabsToggleDocuments] = useState(1);
    const [tabsToggleLicenses, setTabsToggleLicenses] = useState(1);

    const [firstAPIRes, setFirstAPIRes] = useState(false)

    const [proDocumentsArr, setProDocumentsArr] = useState([])

    const [documentNotes, setDocumentNotes] = useState('');
    const [fileSizeLimitErr, setFileSizeLimitErr] = useState(false);

    const [documentObject, setDocumentObject] = useState({});



    const handleDocumentNotes = (e) => {
        setDocumentNotes(e.target.value);
    }

    // Tooltips here
    const tooltipView = (
        <Tooltip id="tooltip" >
            <strong >View Document</strong>
        </Tooltip>
    );

    // Getting file size function 
    function fileSizeSI(a, b, c, d, e) {
        return (b = Math, c = b.log, d = 1e3, e = c(a) / c(d) | 0, a / b.pow(d, e)).toFixed(2)
            + ' ' + (e ? 'kMGTPEZY'[--e] + 'B' : 'Bytes')
    }


    function setInitialDocumentsFn(res) {
        setDocumentsDetails(res);
        setDocumentsDetailsLength(res.data.data?.licence_documents?.length);

        setUploadedLicence0(res.data.data?.licence_documents[0]?.document_url_chr);
        setUploadedLicence0State(res.data.data?.licence_documents[0]?.state_name_chr);
        setUploadedLicence0Country(res.data.data?.licence_documents[0]?.country_name_chr);

        setUploadedLicence1(res.data.data?.licence_documents[1]?.document_url_chr);
        setUploadedLicence1State(res.data.data?.licence_documents[1]?.state_name_chr);
        setUploadedLicence1Country(res.data.data?.licence_documents[1]?.country_name_chr);

        setUploadedLicence2(res.data.data?.licence_documents[2]?.document_url_chr);
        setUploadedLicence2State(res.data.data?.licence_documents[2]?.state_name_chr);
        setUploadedLicence2Country(res.data.data?.licence_documents[2]?.country_name_chr);

        setUploadedAddress(res.data.data?.address_document?.document_url_chr);
        setUploadedInsurence(res.data.data?.insurance_document?.document_url_chr);

        res.data.data?.licence_documents[0]?.licence_document_id_ids !== undefined && setLicenceDocID0(res.data.data?.licence_documents[0]?.licence_document_id_ids);
        res.data.data?.licence_documents[1]?.licence_document_id_ids !== undefined && setLicenceDocID1(res.data.data?.licence_documents[1]?.licence_document_id_ids);
        res.data.data?.licence_documents[2]?.licence_document_id_ids !== undefined && setLicenceDocID2(res.data.data?.licence_documents[2]?.licence_document_id_ids);
        res.data.data?.address_document?.address_document_id_ids !== undefined && setAddressDocID(res.data.data?.address_document?.address_document_id_ids);
        res.data.data?.insurance_document?.insurance_document_id_ids !== undefined && setInsurenceDocID(res.data.data?.insurance_document?.insurance_document_id_ids);

    }

    // Get the documents for the professionals
    useEffect(() => {
        let details = {
            user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
        }
        setFirstAPIRes(true)
        dispatch(
            getDocuments(details,
                (res) => {
                    // console.log(res)
                    setInitialDocumentsFn(res);
                    setFirstAPIRes(false)
                    setProDocumentsArr(res?.data?.data?.pro_documents)
                },
                (res) => {
                    setFirstAPIRes(false)
                }
            )
        )

    }, [])

    // Upload Individual Documents
    // Licence Upload 1
    const licenceDoc0Ref = useRef();

    const handleClickLicenceDoc0 = () => {
        licenceDoc0Ref.current.click();
        setStateApiFlag(true);
    }
    function handleLicenceDoc0(e) {
        if (e.target.files) {
            setLicenceDoc0(e.target.files[0]);
            setLicenceDocImgPre0(URL.createObjectURL(e.target.files[0]))
            setLicenceDocPdfCheckPre(URL.createObjectURL(e.target.files[0]))
        }
    }
    // console.log(licenceDoc0)

    function deleteLicenceDoc0() {
        setLicenceDoc0(null)
        setLicenceDocImgPre0(null)
        setLicenceDocPdfCheckPre(null)
        setLicenceDocCountry0('')
        setLicenceDocState0('')
    }

    function handleLicenceDocCountry0(e) {
        setLicenceDocCountry0(e.target.value)
    }

    function handleLicenceDocState0(e) {
        setLicenceDocState0(e.target.value)
    }

    // Licence Upload 2
    const licenceDoc1Ref = useRef();

    const handleClickLicenceDoc1 = () => {
        licenceDoc1Ref.current.click();
        setStateApiFlag(true);
    }
    function handleLicenceDoc1(e) {
        if (e.target.files) {
            setLicenceDoc1(e.target.files[0]);
            setLicenceDocImgPre1(URL.createObjectURL(e.target.files[0]))
            // setLicenceDocPdfCheckPre(URL.createObjectURL(e.target.files[0]))
        }
    }

    function deleteLicenceDoc1() {
        setLicenceDoc1(null)
        setLicenceDocImgPre1(null)
        // setLicenceDocPdfCheckPre(null)
        setLicenceDocCountry1('');
        setLicenceDocState1('')
    }

    function handleLicenceDocCountry1(e) {
        setLicenceDocCountry1(e.target.value)
    }
    function handleLicenceDocState1(e) {
        setLicenceDocState1(e.target.value)
    }

    // Licence Upload 3
    const licenceDoc2Ref = useRef();

    const handleClickLicenceDoc2 = () => {
        licenceDoc2Ref.current.click();
        setStateApiFlag(true);
    }
    function handleLicenceDoc2(e) {
        if (e.target.files) {
            setLicenceDoc2(e.target.files[0]);
            setLicenceDocImgPre2(URL.createObjectURL(e.target.files[0]))
            // setLicenceDocPdfCheckPre(URL.createObjectURL(e.target.files[0]))
        }
    }

    function deleteLicenceDoc2() {
        setLicenceDoc2(null)
        setLicenceDocImgPre2(null)
        // setLicenceDocPdfCheckPre(null)
        setLicenceDocCountry2('')
        setLicenceDocState2('')
    }
    function handleLicenceDocCountry2(e) {
        setLicenceDocCountry2(e.target.value)
    }
    function handleLicenceDocState2(e) {
        setLicenceDocState2(e.target.value)
    }

    // Address Prof Upload 
    const addressDocRef = useRef();

    const handleClickAddressDoc = () => {
        addressDocRef.current.click();
    }
    function handleAddressDoc(e) {
        if (e.target.files) {
            setAddressDoc(e.target.files[0]);
            setAddressDocImgPre(URL.createObjectURL(e.target.files[0]))
            setAddressDocPdfCheckPre(URL.createObjectURL(e.target.files[0]))
        }
    }
    // console.log(addressDoc)

    function deleteAddressDoc() {
        setAddressDoc(null)
        setAddressDocImgPre(null)
        setAddressDocPdfCheckPre(null)
    }

    // Insurence Upload 
    const insurenceDocRef = useRef();

    const handleClickInsurenceDoc = () => {
        insurenceDocRef.current.click();
    }
    function handleInsurenceDoc(e) {
        if (e.target.files) {
            setInsurenceDoc(e.target.files[0]);
            setInsurenceDocImgPre(URL.createObjectURL(e.target.files[0]))
            setAddressDocPdfCheckPre(URL.createObjectURL(e.target.files[0]))
        }
    }
    // console.log(addressDoc)

    function deleteInsurenceDoc() {
        setInsurenceDoc(null)
        setInsurenceDocImgPre(null)
        setInsurenceDocPdfCheckPre(null)
    }

    function clearDocumentFn() {
        deleteLicenceDoc0();
        deleteLicenceDoc1();
        deleteLicenceDoc2();
        deleteAddressDoc();
        deleteInsurenceDoc();

        setLicenceDocCountry0('')
        setLicenceDocState0('');
        setLicenceDocCountry1('')
        setLicenceDocState1('');
        setLicenceDocCountry2('')
        setLicenceDocState2('');
    }

    function uploadProfessionalDocuments() {
        // setUploadDocumentsLoading(true);
        setUpdateDocumentsLoading(true);
        setApiResponse(true)
        let details = new FormData();

        details.append("user_id_ids", !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"));

        licenceDoc0 !== null && licenceDocID0 !== undefined ? details.append("licence_document_id_ids0", licenceDocID0) : details.append("licence_document_id_ids0", '');
        licenceDoc0 !== null && details.append("licence_document0", licenceDoc0);
        licenceDoc0 !== null && details.append("country_name_chr0", licenceDocCountry0);
        licenceDoc0 !== null && details.append("state_name_chr0", licenceDocState0);

        licenceDoc1 !== null && licenceDocID1 !== undefined ? details.append("licence_document_id_ids1", licenceDocID1) : details.append("licence_document_id_ids1", '');
        licenceDoc1 !== null && details.append("licence_document1", licenceDoc1);
        licenceDoc1 !== null && details.append("country_name_chr1", licenceDocCountry1);
        licenceDoc1 !== null && details.append("state_name_chr1", licenceDocState1);

        licenceDoc2 !== null && licenceDocID2 !== undefined ? details.append("licence_document_id_ids2", licenceDocID2) : details.append("licence_document_id_ids2", '');
        licenceDoc2 !== null && details.append("licence_document2", licenceDoc2);
        licenceDoc2 !== null && details.append("country_name_chr2", licenceDocCountry2);
        licenceDoc2 !== null && details.append("state_name_chr2", licenceDocState2);

        addressDoc !== null && addressDocID ? details.append("address_document_id_ids", addressDocID) : details.append("address_document_id_ids", '');
        addressDoc !== null && details.append("address_document", addressDoc);

        insurenceDoc !== null && insurenceDocID ? details.append("insurance_document_id_ids", insurenceDocID) : details.append("insurance_document_id_ids", '');
        insurenceDoc !== null && details.append("insurance_document", insurenceDoc);

        dispatch(
            uploadDocuments(details,
                (res) => {
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    let details = {
                        user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
                    }
                    dispatch(
                        getDocuments(details,
                            (res) => {
                                // console.log(res)
                                setInitialDocumentsFn(res)
                                setProDocumentsArr(res?.data?.data?.pro_documents)
                            })
                    )
                    setDocumentsModalTrigger(false);
                    setUpdateDocumentsLoading(false);
                    setApiResponse(false)
                    clearDocumentFn();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {

                    setResponceMsg(res.data.message)
                    setToasterType("error")
                    setUpdateDocumentsLoading(false);
                    setApiResponse(false)
                    clearDocumentFn();
                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
        )
    }

    // console.log(documentsDetails)
    // console.log(documentsDetailsLength)


    const [documentType, setDocumentType] = useState();
    const [imageAttachURL, setImageAttachURL] = useState('');
    const [openDoc, setOpenDoc] = React.useState(false);
    const handleOpenDoc = (docType) => {
        setDocumentType(docType);
        setOpenDoc(true);
    }
    const handleCloseDoc = () => setOpenDoc(false);


    // Get the country for document 
    // const [countryArr, setCountryArr] = useState([]);
    const [stateArr, setStateArr] = useState([]);
    const [getStateApiFlag, setStateApiFlag] = useState(false);
    const getStatesData = () => {
        let data = {
            country_id_ids: 1
        }
        dispatch(
            getStateByCountryId(data,
                (res) => {
                    setStateArr(res.data)
                    // console.log(res, "here is ----------------------");
                })
        )
    }

    // useEffect(() => {
    //     if (getStateApiFlag) {
    //         getStatesData();
    //     }
    // }, [getStateApiFlag]);





    // useEffect(() => {
    //     if (!adminTrigger) {
    //         let details = {}
    //         dispatch(
    //             getCountryCode(details, (res) => {
    //                 dispatch(setCountryArr(res.data))
    //             }),
    //         )

    //         let data = {
    //             country_id_ids: 1
    //         }

    //         dispatch(
    //             getStateByCountryId(data,
    //                 (res) => {
    //                     setStateArr(res.data)
    //                     // console.log(res, "here is ----------------------");
    //                 })
    //         )
    //     }
    // }, [])
    const handleOpenDocumentsModal = () => {
        setDocumentsModalTrigger(true);
        setStateApiFlag(true);

        setShowPopover1(false);
        setShowPopover2(false);
        setShowPopover3(false);
        setShowPopover4(false);
        setShowPopover5(false);
        setShowPopover6(false);
    }
    const handleCloseDocumentsModal = () => {
        setDocumentsModalTrigger(false);
        handleClearDocStates();
    }

    const [showPopover, setShowPopover] = useState(false);

    const [showPopover1, setShowPopover1] = useState(false);
    const [showPopover2, setShowPopover2] = useState(false);
    const [showPopover3, setShowPopover3] = useState(false);
    const [showPopover4, setShowPopover4] = useState(false);
    const [showPopover5, setShowPopover5] = useState(false);
    const [showPopover6, setShowPopover6] = useState(false);

    const popover = (docMainTabsVal = 1, docSubTabsVal = 1) => (
        <Popover
            id="popover-basic"
            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}>
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div onClick={() => {
                        handleOpenDocumentsModal();
                        // setShowPopover(false);
                        setTabsToggleDocuments(docMainTabsVal);
                        setTabsToggleLicenses(docSubTabsVal);
                    }} className=' cursor-pointer p-2  text-black overlay-action-btn'>
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Edit</span>
                    </div>

                    <div
                        onClick={(e) => {
                            // handleOpenExpertiseTrigger(e, 3, expertiseObject.expertise_id_ids);
                            // setActivePopover(null)
                            handleOpenDeleteDocumentModal()
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>

                </div>
            </Popover.Body>
        </Popover>
    );

    // Functions for deleting particular document
    const [deleteDocumentModalTrigger, setDeleteDocumentModalTrigger] = useState(false);

    const [deleteDocumentType, setDeleteDocumentType] = useState(1);
    const [deleteDocumentId, setDeleteDocumentId] = useState('');

    const handleOpenDeleteDocumentModal = () => {
        setDeleteDocumentModalTrigger(true);

        setShowPopover1(false);
        setShowPopover2(false);
        setShowPopover3(false);
        setShowPopover4(false);
        setShowPopover5(false);
        setShowPopover6(false);
    }

    const handleCloseDeleteDocumentModal = () => {
        setDeleteDocumentModalTrigger(false);
        handleClearDocStates();
    }


    function delelteDocumentByIdFn() {
        setUpdateDocumentsLoading(true);
        setApiResponse(true)
        // let details = {
        //     document_id_ids: deleteDocumentId,
        //     document_type: parseInt(deleteDocumentType),
        // };

        let details = {
            document_id_ids: documentObject.document_id_ids,
            document_type: parseInt(documentObject.document_type_int),
        };


        dispatch(
            deleteDocumentById(details,
                (res) => {
                    setResponceMsg(res.data.message)
                    setToasterType("success")
                    let details = {
                        user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
                    }
                    dispatch(
                        getDocuments(details,
                            (res) => {
                                // console.log(res)
                                setInitialDocumentsFn(res);
                                setProDocumentsArr(res?.data?.data?.pro_documents)
                            })
                    )
                    handleCloseDeleteDocumentModal();

                    setDocumentsModalTrigger(false);
                    setUpdateDocumentsLoading(false);
                    setApiResponse(false)
                    clearDocumentFn();

                    // setHandleToaster(true);
                    // setTimeout(() => {
                    //     setHandleToaster(false);
                    // }, 11000);
                },
                (res) => {

                    setResponceMsg(res.data.message)
                    setToasterType("error")
                    setUpdateDocumentsLoading(false);
                    setApiResponse(false)
                    clearDocumentFn();
                    setHandleToaster(true);
                    setTimeout(() => {
                        setHandleToaster(false);
                    }, 11000);
                })
        )
    }

    // Upload the professional documents new functions
    const [toggleForDocuments, setToggleForDocuments] = useState(1);
    const [documentTypeInt, setDocumentTypeInt] = useState();
    const [documentTypeName, setDocumentTypeName] = useState('');
    const [documentId, setDocumentId] = useState('');
    const [documentCountryName, setDocumentCountryName] = useState('');
    const [documentCountryId, setDocumentCountryId] = useState('');
    const [isDocumentErr, setIsDocumentErr] = useState(false);
    const [documentStateName, setDocumentStateName] = useState('');
    const [documentStateId, setDocumentStateId] = useState('');
    const [uploadDoc, setUploadDoc] = useState(null);
    const [uploadDocImgPre, setUploadDocImgPre] = useState();

    // console.log("uploadDoc", uploadDoc)


    const documentTypesArr = [
        { id: 1, name: 'Identity', description: 'Drivers license, passport, identity card' },
        { id: 2, name: 'Certificate', description: 'School transcripts, skill certifications' },
        // { id: 3, name: 'Address', description: 'Helps to verify your identity' },
        { id: 4, name: 'Insurance', description: 'Insurance, bonds' },
    ]

    const handleDocumentCountryName = (e) => {
        setDocumentCountryName(e.target.value);
    }

    const handleDocumentStateName = (e) => {
        setDocumentStateName(e.target.value);
    }

    useEffect(() => {
        if (documentCountryName !== "") {
            countryCodeArr.map((item) => {
                if (item.country_name_chr === documentCountryName) {
                    setDocumentCountryId(item.country_id_ids);
                }
            })
        }
    }, [documentCountryName]);

    useEffect(() => {
        if (documentStateName !== "") {
            stateArr.map((item) => {
                if (item.state_name_chr === documentStateName) {
                    setDocumentStateId(item.state_id_ids);
                }
            })
        }
    }, [documentStateName]);

    // console.log("documentCountryName->", documentCountryName, " documentCountryId-> ", documentCountryId)
    // console.log("documentStateName->", documentStateName, " documentStateId-> ", documentStateId)

    // Upload document ->
    const uploadDocRef = useRef();


    const [pdfFile, setPdfFile] = useState(null);
    // const [numPages, setNumPages] = useState(null);

    const handleClickUploadDoc = () => {
        uploadDocRef.current.click();
        setStateApiFlag(true);
    }

    const handleUploadDoc = (e) => {
        if (e.target.files) {
            setUploadDoc(e.target.files[0]);
            setUploadDocImgPre(URL.createObjectURL(e.target.files[0]));
            setIsDocumentErr(false);
            e.target.value = null;

            // console.log("e.target.files[0]", e.target.files[0])
        }

        // if (e.target.files) {
        //     const file = e.target.files[0];
        //     const fileType = file.type;

        //     if (fileType.startsWith('image/')) {
        //         setUploadDoc(file);
        //         setUploadDocImgPre(URL.createObjectURL(file));
        //         setPdfFile(null); // Reset PDF preview
        //     } else if (fileType === 'application/pdf') {
        //         setUploadDoc(file);
        //         setUploadDocImgPre(null); // Reset image preview
        //         setPdfFile(URL.createObjectURL(file));
        //     }
        //     setIsDocumentErr(false);
        //     e.target.value = null; // Clear the input value to allow re-upload of the same file
        // }
    }

    const deleteUploadDoc = () => {
        setUploadDoc(null);
        setUploadDocImgPre(null);
        setFileSizeLimitErr(false);
    }

    const handleDocTypeSelected = (element) => {
        setDocumentTypeInt(element.id);
        setDocumentTypeName(element.name);
        setToggleForDocuments(2);
    }

    const handleClearDocStates = () => {
        setToggleForDocuments(1);
        setDocumentTypeInt();
        setDocumentTypeName(``);
        setDocumentId(``);
        deleteUploadDoc();
        setDocumentCountryName(``);
        setDocumentCountryId(``);
        setDocumentStateName(``);
        setDocumentStateId(``);
        setIsDocumentErr(false);
        setDocumentObject({});

        setDocumentNotes(``);
        setFileSizeLimitErr(false);
    }

    const uploadProfessionalDocumentFn = () => {

        if (uploadDoc) {

            if (uploadDoc.size < 20 * 1024 * 1024) {

                setUpdateDocumentsLoading(true);
                setApiResponse(true)
                let details = new FormData();

                details.append("user_id_ids", !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"));

                details.append("document_type_int", documentTypeInt);
                details.append("document_id_ids", documentId);
                details.append("document_file", uploadDoc);
                documentCountryId && details.append("country_id_ids", documentCountryId);
                documentCountryName && details.append("country_name_chr", documentCountryName);
                documentStateId && details.append("state_id_ids", documentStateId);
                documentStateName && details.append("state_name_chr", documentStateName);
                documentNotes && details.append("note_chr", documentNotes);


                dispatch(
                    uploadDocumentApi(details,
                        (res) => {
                            setResponceMsg(res.data.message)
                            setToasterType("success")
                            let details = {
                                user_id_ids: !adminTrigger ? localStorage.getItem('user_id') : localStorage.getItem("user_id_for_admin"),
                            }
                            dispatch(
                                getDocuments(details,
                                    (res) => {
                                        // console.log(res)
                                        setInitialDocumentsFn(res);
                                        setProDocumentsArr(res?.data?.data?.pro_documents);
                                    })
                            )
                            handleCloseDocumentsModal();
                            setUpdateDocumentsLoading(false);
                            setApiResponse(false)

                            handleClearDocStates();

                            // setHandleToaster(true);
                            // setTimeout(() => {
                            //     setHandleToaster(false);
                            // }, 11000);
                        },
                        (res) => {
                            setResponceMsg(res.data.message)
                            setToasterType("error")
                            setUpdateDocumentsLoading(false);
                            setApiResponse(false)

                            setHandleToaster(true);
                            setTimeout(() => {
                                setHandleToaster(false);
                            }, 11000);
                        })
                )
            } else {
                setFileSizeLimitErr(true);
            }
        } else {
            setIsDocumentErr(true);
        }
    }

    const popoverDocument = (index) => (
        <Popover
            // id="popover-basic"
            id={`popover-basic-${index}`}

            //   className="custom-popover"
            style={{ minWidth: "100px", border: 'none' }}
        >
            <Popover.Body
                className="p-2 popover-body"
                style={{
                    //   padding: "5px",
                    boxShadow: "0px 0px 15px 0px rgba(0, 0, 0, 0.2)",

                }}
            >
                <div className="d-flex flex-column font-w500 fs-6" style={{}}>
                    <div
                        onClick={(e) => {
                            editDocument(e, documentObject);
                            setActivePopover(null)
                        }}
                        className='border-bottom cursor-pointer p-2  text-black overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-pencil"></i>
                        </span>
                        <span>Edit</span>
                    </div>
                    <div
                        onClick={(e) => {
                            handleOpenDeleteDocumentModal()
                            setActivePopover(null)
                        }}
                        className=' cursor-pointer p-2 text-danger overlay-action-btn'
                    >
                        <span className='me-2'>
                            <i className="bi bi-trash"></i>
                        </span>
                        <span>Delete</span>
                    </div>
                </div>
            </Popover.Body>
        </Popover>
    );

    const [activePopover, setActivePopover] = useState(null);

    const editDocument = (e, documentObject) => {
        e.stopPropagation();

        setToggleForDocuments(2);

        setDocumentId(documentObject.document_id_ids);
        setDocumentTypeInt(documentObject.document_type_int);
        documentObject.country_name_chr && setDocumentCountryName(documentObject.country_name_chr);
        documentObject.country_id_lng && setDocumentCountryId(documentObject.country_id_lng);
        documentObject.state_name_chr && setDocumentStateName(documentObject.state_name_chr);
        documentObject.state_id_lng && setDocumentStateId(documentObject.state_id_lng);
        documentObject.note_chr && setDocumentNotes(documentObject.note_chr);

        setDocumentTypeName(
            documentObject?.document_type_int == 1 ? "Identity" :
                documentObject?.document_type_int == 2 ? "Certificate" :
                    documentObject?.document_type_int == 3 ? "Address" :
                        documentObject?.document_type_int == 4 ? "Insurance" : "Other"
        )

        handleOpenDocumentsModal();
    }

    const handleMenuClick = (element, index) => {
        setDocumentObject(element)
        setActivePopover(activePopover === index ? null : index)
    }

    const url = 'https://file-examples.com/storage/fe45dfa76e66c6232a111c9/2017/10/file-example_PDF_1MB.pdf'

    const numPages = useRef(null);

    function onDocumentLoadSuccess({ numPages: loadedNumPages }) {
        numPages.current = loadedNumPages;
    }

    useEffect(() => {
        if (documentsModalTrigger) {
            dispatch(setDocumentsModalTriggerRedux(true));
        } else if (!documentsModalTrigger) {
            dispatch(setDocumentsModalTriggerRedux(false));
        }
    }, [documentsModalTrigger])

    return (
        <>
            <Card className='w-100' style={{ position: 'relative' }}>

                {/* <iframe
                    src="https://file-examples.com/storage/fe45dfa76e66c6232a111c9/2017/10/file-example_PDF_1MB.pdf"
                    title='Doc'

                    frameborder="0"
                    allow="clipboard-write"
                    webkitallowfullscreen="true"
                    mozallowfullscreen="true"
                    allowfullscreen
                    style={{
                        position: 'fixed',
                        top: '50%',
                        left: "50%",
                        transform: 'translate(-50%, -50%)',
                        width: '100vw',
                        height: '100vh',
                        zIndex: 9999,
                    }}
                ></iframe> */}
                {/* <div>
                    <Document
                        file={url}
                        onLoadSuccess={onDocumentLoadSuccess}
                        options={{ workerSrc: "/pdf.worker.js" }}
                    >
                        {Array.from(new Array(numPages.current), (el, index) => (
                            <Page key={`page_${index + 1}`} pageNumber={index + 1} />
                        ))}
                    </Document>
                </div> */}

                {/* <div style={{ width: '100%', height: '500px' }}>
                    <iframe
                        // src={`https://chilllblob.blob.core.windows.net/dev/users/user_177/professional_43/documents/type_1/Subscription flow chart.pdf`}
                        // src={`https://file-examples.com/storage/fe45dfa76e66c6232a111c9/2017/10/file-example_PDF_1MB.pdf`}
                        // src={`https://docs.google.com/gviewer?url=${encodeURIComponent(url)}&embedded=true`}
                        // src={`https://chilllblob.blob.core.windows.net/dev/users/user_5d45921ca8c44960a5284f576bed20c6/professional_3b2933c5155b437abf80b7d685964698/documents/type_4/service_994d38d555df42c1a35d11a816c3cf25_purchase_list-1.pdf`}
                        src={"https://chilllblob.blob.core.windows.net/dev/users/user_177/professional_43/documents/type_1/service_994d38d555df42c1a35d11a816c3cf25_purchase_list (1).pdf"}
                       
                        title="PDF Preview"
                        width="100%"
                        height="100%"
                        style={{ border: 'none' }}
                        contentType="text/html"
                    >
                        This browser does not support PDFs. Please download the PDF to view it: <a href={"https://chilllblob.blob.core.windows.net/dev/users/user_177/professional_43/documents/type_1/service_994d38d555df42c1a35d11a816c3cf25_purchase_list.pdf"}>Download PDF</a>
                    </iframe>
                </div> */}


                <div className='row mx-0  w-100 h-100'>
                    <div className=' col-12 p-4' >
                        <div className='row border-3  mx-0 pb-2'>
                            <div className='col-9 fs-4 fw-bold px-0 text-black'>
                                <span>My documents</span>
                            </div>
                            <div className='col-3 fs-4 fw-normal px-0 text-end'>
                                <span onClick={handleOpenDocumentsModal} className='cursor-pointer font-w500 overlay-action-btn px-2 rounded-1'>Add</span>
                            </div>
                        </div>

                        <>
                            {proDocumentsArr.length > 0 ?
                                <>
                                    {proDocumentsArr.map((item, index) => {
                                        return (
                                            <div
                                                className='bg-white border rounded-3  col-12 mb-2 p-3 shadow-sm'
                                                key={index}
                                            >
                                                <div className='row mx-0'>
                                                    <div className='col-12 px-0 d-flex'>
                                                        <div
                                                            className='align-items-center d-flex justify-content-center rounded-3 border text-black me-3 overflow-hidden'
                                                            style={{ width: '70px', height: '50px' }}
                                                        >
                                                            {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                            <img
                                                                onClick={() => {
                                                                    handleOpenDoc(); setImageAttachURL(item?.document_url_chr);
                                                                }}
                                                                className='documents-individual-box-img rounded-3 w-100 h-100'
                                                                src={item?.document_url_chr}
                                                                alt=''
                                                                style={{ objectFit: 'contain' }}
                                                            />
                                                        </div>

                                                        <div className='d-flex justify-content-between w-100'>
                                                            <div className='px-0 text-black'>
                                                                <div className='fs-6 fw-bold row mb-1'>
                                                                    <span>
                                                                        {item?.document_type_int == 1 ? "Identity" :
                                                                            item?.document_type_int == 2 ? "Certification" :
                                                                                item?.document_type_int == 3 ? "Address" :
                                                                                    item?.document_type_int == 4 ? "Insurance" : "Other"}
                                                                    </span>
                                                                </div>

                                                                <div className='row fs-7'>
                                                                    <span>{item?.note_chr}</span>
                                                                </div>

                                                                {/* <div className='row fs-7'>
                                                            {(item?.country_name_chr || item?.state_name_chr) && <span>{`${item?.country_name_chr && item?.country_name_chr}, ${item?.state_name_chr && item?.state_name_chr}`}</span>}
                                                        </div> */}

                                                                {/* <div className='font-w500 row fs-7 '>
                                                            <div>
                                                                <i className="bi bi-patch-check-fill pe-2 text-success"></i>
                                                                <span >
                                                                    {item?.note_chr}
                                                                </span>
                                                            </div>
                                                        </div> */}
                                                            </div>

                                                            <div className=' px-0 text-black'>
                                                                <div className='fs-5 fw-bold row mb-1'>
                                                                    <div className="tooltipCustom">
                                                                        <span className="tooltiptextCustom w-100" style={{ minWidth: "max-content" }}>{"More"}</span>
                                                                        <OverlayTrigger
                                                                            key={index}
                                                                            trigger="click"
                                                                            placement="bottom"
                                                                            overlay={popoverDocument(index)}
                                                                            rootClose={true}
                                                                            show={activePopover === index}
                                                                            onToggle={(show) => setActivePopover(show ? index : null)}
                                                                        >
                                                                            <span
                                                                                className='d-flex align-items-center justify-content-center more-option rounded-circle'
                                                                                style={{ height: '30px', width: '30px' }}
                                                                                onClick={() => handleMenuClick(item, index)}
                                                                            >
                                                                                <i class="bi bi-three-dots-vertical cursor-pointer"></i>
                                                                            </span>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                </div>
                                            </div>
                                        )
                                    })}

                                </>
                                :
                                <div className='row align-items-center border-3 border-black h-100 justify-content-center mx-0 '>
                                    <div className='col-12 px-0' >
                                        <div className='row align-items-center justify-content-center mx-0'>
                                            <div className='col-12 rounded-circle bg-white' style={{ height: '5rem', width: '5rem', }}>

                                            </div>
                                        </div>

                                        <div className='align-items-center justify-content-center mx-0 pt-3 row'>
                                            <div className='col-12 px-0 text-center fs-7'>
                                                <span>
                                                    {"You have not added any document yet. This is needed in order to check your specialty."}
                                                </span>
                                            </div>
                                        </div>

                                        <div className='align-items-center justify-content-center mx-0 pt-4 pb-5 row'>
                                            <div className='align-items-center col-12 d-flex justify-content-center'>
                                                <div onClick={handleOpenDocumentsModal} className='cursor-pointer fs-6 fw-bold text-black text-center overlay-action-btn px-2 py-1 rounded-1'>
                                                    <i className="bi bi-plus-circle pe-3"></i>
                                                    <span >
                                                        {"Add document"}
                                                    </span>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            }
                        </>

                        {(documentsDetailsLength > 0 || uploadedAddress || uploadedInsurence) && false ?
                            <div className='row h-100 mx-0 '>
                                <div className='col-12 px-0' style={{}}>
                                    <div className='mt-2 mx-0 row'>



                                        {uploadedLicence0 &&
                                            <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                                <div className='row mx-0'>

                                                    <div className='align-items-center col-4 col-md-3 d-flex px-0 '>
                                                        <div className='align-items-cente bg-light border d-flex justify-content-center text-black h-100 w-75 overflow-hidden'>
                                                            {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                            <img onClick={() => handleOpenDoc(1)} className='documents-individual-box-img rounded-0' src={uploadedLicence0}
                                                                alt='Error'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-7 col-md-8 px-0 text-black'>
                                                        <div className='fs-6 fw-bold row mb-1'>
                                                            <span>{"Licence 1"}</span>
                                                        </div>
                                                        <div className='row fs-7'>
                                                            {(uploadedLicence0Country || uploadedLicence0State) && <span>{`${uploadedLicence0Country != null && uploadedLicence0Country}, ${uploadedLicence0State != null && uploadedLicence0State}`}</span>}
                                                        </div>
                                                        <div className='font-w500 row fs-7 '>
                                                            <div>
                                                                <i className="bi bi-patch-check-fill pe-2 text-success"></i>
                                                                <span >
                                                                    {"Verified"}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className='col-1 col-md-1 px-0 text-black'>
                                                        <div className='fs-5 fw-bold row mb-1'>
                                                            <div className="tooltipCustom">
                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: "max-content" }}>{"More"}</span>
                                                                <span className='d-flex align-items-center justify-content-center more-option rounded-circle' >
                                                                    <OverlayTrigger
                                                                        trigger="click"
                                                                        placement="bottom"
                                                                        overlay={popover(1, 1)}
                                                                        rootClose={true}
                                                                        show={showPopover1}
                                                                        onToggle={(isOpen) => setShowPopover1(isOpen)}
                                                                    >
                                                                        <i
                                                                            onClick={() => {
                                                                                setDeleteDocumentId(licenceDocID0);
                                                                                setDeleteDocumentType(1);
                                                                            }}
                                                                            className="bi bi-three-dots-vertical cursor-pointer"
                                                                        ></i>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        }

                                        {uploadedLicence1 &&
                                            <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                                <div className='row mx-0'>

                                                    <div className='align-items-center col-4 col-md-3 d-flex px-0'>
                                                        <div className='align-items-cente bg-light border d-flex justify-content-center text-black h-100 w-75 overflow-hidden'>
                                                            {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                            <img onClick={() => handleOpenDoc(7)} className='documents-individual-box-img rounded-0' src={uploadedLicence1}
                                                                alt='Error'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-7 col-md-8 px-0 text-black'>
                                                        <div className='fs-6 fw-bold row mb-1'>
                                                            <span>{"Licence 2"}</span>
                                                        </div>
                                                        <div className='row fs-7'>
                                                            {(uploadedLicence1Country || uploadedLicence1State) && <span>{`${uploadedLicence1Country != null && uploadedLicence1Country}, ${uploadedLicence1State != null && uploadedLicence1State}`}</span>}
                                                        </div>
                                                        <div className='font-w500 row fs-7 '>
                                                            <div>
                                                                <i className="bi bi-patch-check-fill pe-2 text-success"></i>
                                                                <span >
                                                                    {"Verified"}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className='col-1 col-md-1 px-0 text-black'>
                                                        <div className='fs-5 fw-bold row mb-1'>
                                                            <div className="tooltipCustom">
                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: "max-content" }}>{"More"}</span>
                                                                <span className='d-flex align-items-center justify-content-center more-option rounded-circle' >
                                                                    <OverlayTrigger
                                                                        trigger="click"
                                                                        placement="bottom"
                                                                        overlay={popover(1, 2)}
                                                                        rootClose={true}
                                                                        show={showPopover2}
                                                                        onToggle={(isOpen) => setShowPopover2(isOpen)}
                                                                    >
                                                                        <i
                                                                            onClick={() => {
                                                                                setDeleteDocumentId(licenceDocID1);
                                                                                setDeleteDocumentType(1);
                                                                            }}
                                                                            class="bi bi-three-dots-vertical cursor-pointer"
                                                                        ></i>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        }

                                        {uploadedLicence2 &&
                                            <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                                <div className='row mx-0'>

                                                    <div className='align-items-center col-4 col-md-3 d-flex px-0'>
                                                        <div className='align-items-cente bg-light border d-flex justify-content-center text-black h-100 w-75 overflow-hidden'>
                                                            {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                            <img onClick={() => handleOpenDoc(8)} className='documents-individual-box-img rounded-0' src={uploadedLicence2}
                                                                alt='Error'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-7 col-md-8 px-0 text-black'>
                                                        <div className='fs-6 fw-bold row mb-1'>
                                                            <span>{"Licence 3"}</span>
                                                        </div>
                                                        <div className='row fs-7'>
                                                            {(uploadedLicence2Country || uploadedLicence2State) && <span>{`${uploadedLicence2Country != null && uploadedLicence2Country}, ${uploadedLicence2State != null && uploadedLicence2State}`}</span>}
                                                        </div>
                                                        <div className='font-w500 row fs-7 '>
                                                            <div>
                                                                <i className="bi bi-patch-check-fill pe-2 text-success"></i>
                                                                <span >
                                                                    {"Verified"}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className='col-1 col-md-1 px-0 text-black'>
                                                        <div className='fs-5 fw-bold row mb-1'>
                                                            <div className="tooltipCustom">
                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: "max-content" }}>{"More"}</span>
                                                                <span className='d-flex align-items-center justify-content-center more-option rounded-circle' >
                                                                    <OverlayTrigger
                                                                        trigger="click"
                                                                        placement="bottom"
                                                                        overlay={popover(1, 3)}
                                                                        rootClose={true}
                                                                        show={showPopover3}
                                                                        onToggle={(isOpen) => setShowPopover3(isOpen)}
                                                                    >
                                                                        <i
                                                                            onClick={() => {
                                                                                setDeleteDocumentId(licenceDocID2);
                                                                                setDeleteDocumentType(1);
                                                                            }}
                                                                            class="bi bi-three-dots-vertical cursor-pointer"
                                                                        ></i>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        }

                                        {uploadedAddress &&
                                            <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                                <div className='row mx-0'>

                                                    <div className='align-items-center col-4 col-md-3 d-flex px-0'>
                                                        <div className='align-items-cente bg-light border d-flex justify-content-center text-black h-100 w-75 overflow-hidden'>
                                                            {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                            <img onClick={() => handleOpenDoc(2)} className='documents-individual-box-img rounded-0' src={uploadedAddress}
                                                                alt='Error'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-7 col-md-8 px-0 text-black'>
                                                        <div className='fs-6 fw-bold row mb-1'>
                                                            <span>{"Address document"}</span>
                                                        </div>
                                                        {/* <div className='row fs-7'>
                                                            <span>{`${uploadedLicence2Country != null && uploadedLicence2Country}, ${uploadedLicence2State != null && uploadedLicence2State}`}</span>
                                                        </div> */}
                                                        <div className='font-w500 row fs-7 '>
                                                            <div>
                                                                <i className="bi bi-patch-check-fill pe-2 text-success"></i>
                                                                <span >
                                                                    {"Verified"}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className='col-1 col-md-1 px-0 text-black'>
                                                        <div className='fs-5 fw-bold row mb-1'>
                                                            <div className="tooltipCustom">
                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: "max-content" }}>{"More"}</span>
                                                                <span className='d-flex align-items-center justify-content-center more-option rounded-circle' >
                                                                    <OverlayTrigger
                                                                        trigger="click"
                                                                        placement="bottom"
                                                                        overlay={popover(2)}
                                                                        rootClose={true}
                                                                        show={showPopover4}
                                                                        onToggle={(isOpen) => setShowPopover4(isOpen)}
                                                                    >
                                                                        <i
                                                                            onClick={() => {
                                                                                setDeleteDocumentId(addressDocID);
                                                                                setDeleteDocumentType(2);
                                                                            }}
                                                                            class="bi bi-three-dots-vertical cursor-pointer"
                                                                        ></i>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {uploadedInsurence &&
                                            <div className='bg-white border col-12 mb-2 p-3 shadow-sm'>
                                                <div className='row mx-0'>

                                                    <div className='align-items-center col-4 col-md-3 d-flex px-0'>
                                                        <div className='align-items-cente bg-light border d-flex justify-content-center text-black h-100 w-75 overflow-hidden'>
                                                            {/* <i class="align-self-center bi bi-gear-wide-connected"></i> */}
                                                            <img onClick={() => handleOpenDoc(3)} className='documents-individual-box-img rounded-0' src={uploadedInsurence}
                                                                alt='Error'
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className='col-7 col-md-8 px-0 text-black'>
                                                        <div className='fs-6 fw-bold row mb-1'>
                                                            <span>{"Insurance document"}</span>
                                                        </div>
                                                        {/* <div className='row fs-7'>
                                                            <span>{`${uploadedLicence2Country != null && uploadedLicence2Country}, ${uploadedLicence2State != null && uploadedLicence2State}`}</span>
                                                        </div> */}
                                                        <div className='font-w500 row fs-7 '>
                                                            <div>
                                                                <i className="bi bi-patch-check-fill pe-2 text-success"></i>
                                                                <span >
                                                                    {"Verified"}
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    <div className='col-1 col-md-1 px-0 text-black'>
                                                        <div className='fs-5 fw-bold row mb-1'>
                                                            <div className="tooltipCustom">
                                                                <span className="tooltiptextCustom w-100" style={{ minWidth: "max-content" }}>{"More"}</span>
                                                                <span className='d-flex align-items-center justify-content-center more-option rounded-circle' >
                                                                    <OverlayTrigger
                                                                        trigger="click"
                                                                        placement="bottom"
                                                                        overlay={popover(3)}
                                                                        rootClose={true}
                                                                        show={showPopover5}
                                                                        onToggle={(isOpen) => setShowPopover5(isOpen)}
                                                                    >
                                                                        <i
                                                                            onClick={() => {
                                                                                setDeleteDocumentId(insurenceDocID);
                                                                                setDeleteDocumentType(3);
                                                                            }}
                                                                            class="bi bi-three-dots-vertical cursor-pointer"
                                                                        ></i>
                                                                    </OverlayTrigger>
                                                                </span>
                                                            </div>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        }


                                    </div>

                                </div>
                            </div> :

                            false &&
                            <div className='row align-items-center border-3 border-black h-100 justify-content-center mx-0 '>
                                <div className='col-12 px-0' >
                                    <div className='row align-items-center justify-content-center mx-0'>
                                        <div className='col-12 rounded-circle bg-white' style={{ height: '5rem', width: '5rem', }}>

                                        </div>
                                    </div>

                                    <div className='align-items-center justify-content-center mx-0 pt-3 row'>
                                        <div className='col-12 px-0 text-center'>
                                            <span>
                                                {"You have not added any document yet. This is needed in order to check your specialty."}
                                            </span>
                                        </div>
                                    </div>

                                    <div className='align-items-center justify-content-center mx-0 pt-4 pb-5 row'>
                                        <div className='align-items-center col-12 d-flex justify-content-center'>
                                            <div onClick={handleOpenDocumentsModal} className='cursor-pointer fs-4 fw-bold text-black text-center'>
                                                <i className="bi bi-plus-circle pe-3"></i>
                                                <span >
                                                    {"Add document"}
                                                </span>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                            </div>
                        }


                    </div>
                </div>

                {firstAPIRes && !adminTrigger && <ResponceForAPI show={firstAPIRes} />}
            </Card>

            {/* Old Modal for add/edit document */}
            <Modal
                className='fade'
                centered
            // show={documentsModalTrigger}
            >
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {"Add documents"}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseDocumentsModal()} className='cursor-pointer'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row '>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {"Choose which document you want to add"}
                                        </span>
                                    </div>

                                </div>

                                <div className='border-bottom m-0 mt-2 mb-3 overflow-auto row text-nowrap user-profile-nav-bar whitespace-nowrap'>
                                    <div className='col-12 d-flex px-0 font-w500'>
                                        <div onClick={() => setTabsToggleDocuments(1)} className='align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-2' style={{}}>
                                            <span className={`${tabsToggleDocuments === 1 ? "text-black" : "text-grey"} ${tabsToggleDocuments === 1 && "fw-bold"}`} >{"Licenses"}</span>
                                            {tabsToggleDocuments === 1 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px" }}> </div>}
                                        </div>

                                        <div onClick={() => setTabsToggleDocuments(2)} className='align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-2' style={{}}>
                                            <span className={`${tabsToggleDocuments === 2 ? "text-black" : "text-grey"} ${tabsToggleDocuments === 2 && "fw-bold"}`}>{"Address"}</span>
                                            {tabsToggleDocuments === 2 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                        </div>

                                        <div onClick={() => setTabsToggleDocuments(3)} className='align-items-cente cursor-pointer d-flex justify-content-center position-relative px-3 py-2' style={{}}>
                                            <span className={`${tabsToggleDocuments === 3 ? "text-black" : "text-grey"} ${tabsToggleDocuments === 3 && "fw-bold"}`}>{"Insurance"}</span>
                                            {tabsToggleDocuments === 3 && <div className='position-absolute w-100 bg-black bottom-0' style={{ height: "3px", }}> </div>}
                                        </div>

                                    </div>
                                </div>

                                {/* Licenses Tab */}
                                {tabsToggleDocuments === 1 &&
                                    <div className='mx-0 row'>
                                        <div className='col-12 px-0'>
                                            <>
                                                <div className='mx-0 row text-black overflow-auto text-nowrap user-profile-nav-bar'>
                                                    <div className='col-12 px-0 d-flex font-w500 align-items-center mb-2'>
                                                        <div onClick={() => setTabsToggleLicenses(1)} className={`${tabsToggleLicenses === 1 ? "bg-black" : "bg-light"} ${tabsToggleLicenses === 1 && "text-white"} ${tabsToggleLicenses === 1 && "font-w600"} cursor-pointer license-type-box me-2 px-3 py-2 rounded-1`}>
                                                            <span>{"License 1"}</span>
                                                        </div>

                                                        <div onClick={() => setTabsToggleLicenses(2)} className={`${tabsToggleLicenses === 2 ? "bg-black" : "bg-light"} ${tabsToggleLicenses === 2 && "text-white"} ${tabsToggleLicenses === 2 && "font-w600"} cursor-pointer license-type-box me-2 px-3 py-2 rounded-1`}>
                                                            <span>{"License 2"}</span>
                                                        </div>

                                                        <div onClick={() => setTabsToggleLicenses(3)} className={`${tabsToggleLicenses === 3 ? "bg-black" : "bg-light"} ${tabsToggleLicenses === 3 && "text-white"} ${tabsToggleLicenses === 3 && "font-w600"} cursor-pointer license-type-box me-2 px-3 py-2 rounded-1`}>
                                                            <span>{"License 3"}</span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {tabsToggleLicenses === 1 &&
                                                    <>
                                                        <div className='mx-0 row'>
                                                            <div className='col-12 px-0 d-flex justify-content-center'>
                                                                <input ref={licenceDoc0Ref} onChange={(e) => { handleLicenceDoc0(e) }} on className="form-control" type="file" accept="image/*, application/pdf, application/vnd.ms-excel" hidden />
                                                                {licenceDoc0 ?
                                                                    <>
                                                                        <div className='d-flex flex-column w-100'>
                                                                            <div className='align-items-center bg-light d-flex flex-column font-w500 fs-4 justify-content-center rounded-3 text-black w-100 position-relative' style={{ height: "200px", }}>
                                                                                <i className="bi bi-x-circle cursor-pointer end-0 me-2 mt-1 position-absolute top-0 fs-3" onClick={(e) => { e.stopPropagation(); deleteLicenceDoc0() }}></i>
                                                                                {licenceDocImgPre0 && <img onClick={() => { handleOpenDoc(4) }} src={licenceDocImgPre0} className='h-100 border cursor-pointer' alt="Document" />}
                                                                            </div>
                                                                            <div className='text-center'>
                                                                                <span>{licenceDoc0.name}</span>
                                                                            </div>
                                                                        </div>
                                                                    </> :
                                                                    <div onClick={handleClickLicenceDoc0} className='align-items-center bg-light cursor-pointer d-flex flex-column font-w500 fs-3 justify-content-center rounded-3 text-black w-100' style={{ height: "200px", }} >
                                                                        <span>
                                                                            <i className="bi bi-plus-circle"></i>
                                                                        </span>
                                                                        <span>
                                                                            {"Choose file"}
                                                                        </span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className='row mx-0 justify-content-between mt-3'>
                                                            <div className='col-md-6 px-0 pe-md-2'>
                                                                <SelectInputCountry
                                                                    labelName={'Country'}
                                                                    onChange={(e) => handleLicenceDocCountry0(e)}
                                                                    defaultValue={licenceDocCountry0}
                                                                    options={countryCodeArr}
                                                                />
                                                            </div>

                                                            <div className='col-md-6 px-0  ps-md-2'>
                                                                <SelectInputState
                                                                    labelName={'State'}
                                                                    defaultValue={licenceDocState0}
                                                                    onChange={(e) => handleLicenceDocState0(e)}
                                                                    options={stateArr}
                                                                />
                                                            </div>

                                                        </div>
                                                    </>
                                                }

                                                {tabsToggleLicenses === 2 &&
                                                    <>
                                                        <div className='mx-0 row'>
                                                            <div className='col-12 px-0 d-flex justify-content-center'>
                                                                <input ref={licenceDoc1Ref} onChange={(e) => { handleLicenceDoc1(e) }} on className="form-control" type="file" accept="image/*, application/pdf, application/vnd.ms-excel" hidden />
                                                                {licenceDoc1 ?
                                                                    <>
                                                                        <div className='d-flex flex-column w-100'>
                                                                            <div className='align-items-center bg-light d-flex flex-column font-w500 fs-4 justify-content-center rounded-3 text-black w-100 position-relative' style={{ height: "200px", }}>
                                                                                <i className="bi bi-x-circle cursor-pointer end-0 me-2 mt-1 position-absolute top-0 fs-3" onClick={(e) => { e.stopPropagation(); deleteLicenceDoc1() }}></i>
                                                                                {licenceDocImgPre1 && <img onClick={() => { handleOpenDoc(9) }} src={licenceDocImgPre1} className='h-100 border cursor-pointer' alt="Document" />}
                                                                            </div>
                                                                            <div className='text-center'>
                                                                                <span>{licenceDoc1.name}</span>
                                                                            </div>
                                                                        </div>
                                                                    </> :
                                                                    <div onClick={handleClickLicenceDoc1} className='align-items-center bg-light cursor-pointer d-flex flex-column font-w500 fs-3 justify-content-center rounded-3 text-black w-100' style={{ height: "200px", }} >
                                                                        <span>
                                                                            <i className="bi bi-plus-circle"></i>
                                                                        </span>
                                                                        <span>
                                                                            {"Choose file"}
                                                                        </span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className='row mx-0 justify-content-between mt-3'>
                                                            <div className='col-md-6 px-0 pe-md-2'>
                                                                <SelectInputCountry
                                                                    labelName={'Country'}
                                                                    onChange={(e) => handleLicenceDocCountry1(e)}
                                                                    defaultValue={licenceDocCountry1}
                                                                    options={countryCodeArr}
                                                                />
                                                            </div>

                                                            <div className='col-md-6 px-0  ps-md-2'>
                                                                <SelectInputState
                                                                    labelName={'State'}
                                                                    defaultValue={licenceDocState1}
                                                                    onChange={(e) => handleLicenceDocState1(e)}
                                                                    options={stateArr}
                                                                />
                                                            </div>

                                                        </div>
                                                    </>
                                                }

                                                {tabsToggleLicenses === 3 &&
                                                    <>
                                                        <div className='mx-0 row'>
                                                            <div className='col-12 px-0 d-flex justify-content-center'>
                                                                <input ref={licenceDoc2Ref} onChange={(e) => { handleLicenceDoc2(e) }} on className="form-control" type="file" accept="image/*, application/pdf, application/vnd.ms-excel" hidden />
                                                                {licenceDoc2 ?
                                                                    <>
                                                                        <div className='d-flex flex-column w-100'>
                                                                            <div className='align-items-center bg-light d-flex flex-column font-w500 fs-4 justify-content-center rounded-3 text-black w-100 position-relative' style={{ height: "200px", }}>
                                                                                <i className="bi bi-x-circle cursor-pointer end-0 me-2 mt-1 position-absolute top-0 fs-3" onClick={(e) => { e.stopPropagation(); deleteLicenceDoc2() }}></i>
                                                                                {licenceDocImgPre2 && <img onClick={() => { handleOpenDoc(10) }} src={licenceDocImgPre2} className='h-100 border cursor-pointer' alt="Document" />}
                                                                            </div>
                                                                            <div className='text-center'>
                                                                                <span>{licenceDoc2.name}</span>
                                                                            </div>
                                                                        </div>
                                                                    </> :
                                                                    <div onClick={handleClickLicenceDoc2} className='align-items-center bg-light cursor-pointer d-flex flex-column font-w500 fs-3 justify-content-center rounded-3 text-black w-100' style={{ height: "200px", }} >
                                                                        <span>
                                                                            <i className="bi bi-plus-circle"></i>
                                                                        </span>
                                                                        <span>
                                                                            {"Choose file"}
                                                                        </span>
                                                                    </div>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className='row mx-0 justify-content-between mt-3'>
                                                            <div className='col-md-6 px-0 pe-md-2'>
                                                                <SelectInputCountry
                                                                    labelName={'Country'}
                                                                    onChange={(e) => handleLicenceDocCountry2(e)}
                                                                    defaultValue={licenceDocCountry2}
                                                                    options={countryCodeArr}
                                                                />
                                                            </div>

                                                            <div className='col-md-6 px-0  ps-md-2'>
                                                                <SelectInputState
                                                                    labelName={'State'}
                                                                    defaultValue={licenceDocState2}
                                                                    onChange={(e) => handleLicenceDocState2(e)}
                                                                    options={stateArr}
                                                                />
                                                            </div>

                                                        </div>
                                                    </>
                                                }
                                            </>
                                        </div>
                                    </div>
                                }

                                {/* Address Document */}
                                {tabsToggleDocuments === 2 &&
                                    <div className='mx-0 row'>
                                        <div className='col-12 px-0'>

                                            <div className='mx-0 row'>
                                                <div className='col-12 px-0 d-flex justify-content-center'>
                                                    <input ref={addressDocRef} onChange={(e) => { handleAddressDoc(e) }} on className="form-control" type="file" accept="image/*, application/pdf, application/vnd.ms-excel" hidden />
                                                    {addressDoc ?
                                                        <>
                                                            <div className='d-flex flex-column w-100'>
                                                                <div className='align-items-center bg-light d-flex flex-column font-w500 fs-4 justify-content-center rounded-3 text-black w-100 position-relative' style={{ height: "200px", }}>
                                                                    <i className="bi bi-x-circle cursor-pointer end-0 me-2 mt-1 position-absolute top-0 fs-3" onClick={(e) => { e.stopPropagation(); deleteAddressDoc() }}></i>
                                                                    {addressDocImgPre && <img onClick={() => { handleOpenDoc(5) }} src={addressDocImgPre} className='h-100 border cursor-pointer' alt="Document" />}
                                                                </div>
                                                                <div className='text-center'>
                                                                    <span>{addressDoc.name}</span>
                                                                </div>
                                                            </div>
                                                        </> :
                                                        <div onClick={handleClickAddressDoc} className='align-items-center bg-light cursor-pointer d-flex flex-column font-w500 fs-3 justify-content-center rounded-3 text-black w-100' style={{ height: "200px", }} >
                                                            <span>
                                                                <i className="bi bi-plus-circle"></i>
                                                            </span>
                                                            <span>
                                                                {"Choose file"}
                                                            </span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                }

                                {tabsToggleDocuments === 3 &&
                                    <div className='mx-0 row'>
                                        <div className='col-12 px-0'>

                                            <div className='mx-0 row'>
                                                <div className='col-12 px-0 d-flex justify-content-center'>
                                                    <input ref={insurenceDocRef} onChange={(e) => { handleInsurenceDoc(e) }} on className="form-control" type="file" accept="image/*, application/pdf, application/vnd.ms-excel" hidden />
                                                    {insurenceDoc ?
                                                        <>
                                                            <div className='d-flex flex-column w-100'>
                                                                <div className='align-items-center bg-light d-flex flex-column font-w500 fs-4 justify-content-center rounded-3 text-black w-100 position-relative' style={{ height: "200px", }}>
                                                                    <i className="bi bi-x-circle cursor-pointer end-0 me-2 mt-1 position-absolute top-0 fs-3" onClick={(e) => { e.stopPropagation(); deleteInsurenceDoc() }}></i>
                                                                    {insurenceDocImgPre && <img onClick={() => { handleOpenDoc(6) }} src={insurenceDocImgPre} className='h-100 border cursor-pointer' alt="Document" />}
                                                                </div>
                                                                <div className='text-center'>
                                                                    <span>{insurenceDoc.name}</span>
                                                                </div>
                                                            </div>
                                                        </> :
                                                        <div onClick={handleClickInsurenceDoc} className='align-items-center bg-light cursor-pointer d-flex flex-column font-w500 fs-3 justify-content-center rounded-3 text-black w-100' style={{ height: "200px", }} >
                                                            <span>
                                                                <i className="bi bi-plus-circle"></i>
                                                            </span>
                                                            <span>
                                                                {"Choose file"}
                                                            </span>
                                                        </div>
                                                    }
                                                </div>
                                            </div>


                                        </div>
                                    </div>
                                }

                                <div className='row mx-0 mt-2'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                uploadProfessionalDocuments()
                                            }}
                                            buttonName={"Upload Documents"}
                                            type="submit"
                                            loadingMessage="Uploading..."
                                            isLoading={updateDocumentsLoading}
                                            style={{ width: '100%' }}
                                        />
                                    </div>
                                </div>
                            </>

                        </div>
                    </div>
                </Modal.Body>
            </Modal >


            {/* New Modal for add/edit document */}
            <Modal className='fade' centered show={documentsModalTrigger}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='row mx-0'>
                                    <div className='col-6 px-0 d-flex justify-content-start align-items-center'>
                                        {toggleForDocuments === 2 && !documentId &&
                                            <div
                                                className='cursor-pointer d-flex align-items-center text-hovered font-w600 fs-5'
                                                onClick={() => handleClearDocStates()}
                                            >
                                                <span>
                                                    <i className='bi bi-arrow-left me-2'></i>
                                                </span>
                                                <span>
                                                    Back
                                                </span>
                                            </div>
                                        }
                                    </div>

                                    <div className='col-6 px-0 d-flex justify-content-end'>
                                        <span onClick={() => handleCloseDocumentsModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-12 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {toggleForDocuments === 1 ? `Add documents` :
                                                toggleForDocuments === 2 ?
                                                    <>{documentId ? `Edit ${documentTypeName}` : `Add ${documentTypeName}`}</> : ''
                                            }
                                        </span>
                                    </div>
                                </div>

                                {toggleForDocuments === 1 &&
                                    <div className='mx-0 row '>
                                        <div className='col-12 font-w500 fs-5 px-0 text-center font-w500'>
                                            <span>
                                                {"Upload your credentials so that Chilll can verify them. Use .pdf, .jpg or .png file. Max size: 20 MB"}
                                            </span>
                                        </div>
                                    </div>
                                }

                                {toggleForDocuments === 2 &&
                                    <div className='mx-0 row mb-3'>
                                        <div className='col-12 font-w500 fs-5 px-0 text-center font-w500'>
                                            <span>
                                                {"Upload .pdf, .jpg or .png file. Max size: 20 MB"}
                                            </span>
                                        </div>
                                    </div>
                                }

                                {toggleForDocuments === 1 &&
                                    <>
                                        <div className='row mx-0 mt-3'>
                                            <div className='col-12 px-0'>

                                                {documentTypesArr.map((element, index) => {
                                                    return (
                                                        <div
                                                            key={index}
                                                            className='row mx-0 mb-3 cursor-pointer overlay-action-btn border rounded-3'
                                                            onClick={() => { handleDocTypeSelected(element) }}
                                                        >
                                                            <div className='col-12 p-2 '>
                                                                <div className='d-flex'>
                                                                    <div>
                                                                        <div
                                                                            className='d-flex justify-content-center align-items-center rounded-3  mx-3'
                                                                            style={{ width: "50px", height: "50px" }}
                                                                        >
                                                                            <img
                                                                                className='w-100 h-100'
                                                                                style={{ objectFit: "contain" }}
                                                                                alt=''
                                                                                src={
                                                                                    element.id === 1 ? proLicense :
                                                                                        element.id === 2 ? proCerificate :
                                                                                            element.id === 4 ? proInsurance : ''
                                                                                }
                                                                            />
                                                                            {/* <i className='bi bi-file-earmark-text fs-2 text-black'></i> */}
                                                                        </div>
                                                                    </div>

                                                                    <div className='d-flex flex-column ms-2'>
                                                                        <div className='font-w600 fs-4 text-black'>
                                                                            <span>{`${element.name}`}</span>
                                                                        </div>

                                                                        <div className='font-w500 fs-6'>
                                                                            <span>{`${element.description}`}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </>
                                }

                                {toggleForDocuments === 2 &&
                                    <>
                                        <div className='mx-0 row my-4'>
                                            <div className='col-12 px-0 d-flex justify-content-center'>
                                                <input ref={uploadDocRef} onChange={(e) => { handleUploadDoc(e) }} on className="form-control" type="file" accept="image/*, application/pdf, application/vnd.ms-excel" hidden />
                                                {uploadDoc ?
                                                    <>
                                                        <div className='d-flex flex-column w-100'>
                                                            <div
                                                                className='align-items-center rounded-2 d-flex flex-column font-w500 fs-4 justify-content-center w-100 position-relative'
                                                                style={{
                                                                    height: "200px",
                                                                    background: 'rgba(244, 248, 255, 1)',
                                                                    color: 'rgba(131, 154, 192, 1)',
                                                                    border: '2px solid rgb(199, 212, 234)',
                                                                }}
                                                            >
                                                                <i className="bi bi-x-circle cursor-pointer end-0 me-2 mt-1 position-absolute top-0 fs-3" onClick={(e) => { e.stopPropagation(); deleteUploadDoc() }}></i>
                                                                {uploadDocImgPre && <img onClick={() => { handleOpenDoc(); setImageAttachURL(uploadDocImgPre); }} src={uploadDocImgPre} className='h-100 border cursor-pointer d-flex align-items-center justify-content-center' alt="Document" />}
                                                            </div>

                                                            {/* <div className='text-center'>
                                                                <span>{uploadDoc.name}</span>
                                                            </div> */}
                                                        </div>
                                                    </> :
                                                    <div onClick={handleClickUploadDoc}
                                                        className='align-items-center rounded-2  cursor-pointer d-flex flex-column font-w600 fs-3 justify-content-center w-100'
                                                        style={{
                                                            height: "200px",
                                                            background: 'rgba(244, 248, 255, 1)',
                                                            color: 'rgba(131, 154, 192, 1)',
                                                            border: '2px solid rgb(199, 212, 234)',
                                                        }}
                                                    >
                                                        <span>
                                                            <i className="bi bi-upload"></i>
                                                        </span>
                                                        <span>
                                                            {"Upload file"}
                                                        </span>
                                                    </div>
                                                }
                                            </div>
                                        </div>

                                        <div className='row mx-0 mt-3'>
                                            <div className='col-12 px-0'>
                                                <InputField
                                                    labelName={"Note"}
                                                    placeholderName={"Note"}
                                                    onChange={handleDocumentNotes}
                                                    onBlur={() => { }}
                                                    errorOccured={``}
                                                    errorMeesage={``}
                                                    value={`${documentNotes}`}
                                                />
                                            </div>
                                        </div>

                                        {documentTypeInt === 5 &&
                                            <div className='row mx-0 justify-content-between mt-3'>
                                                <div className='col-md-6 px-0 pe-md-2'>
                                                    <SelectInputCountry
                                                        labelName={'Country'}
                                                        onChange={(e) => handleDocumentCountryName(e)}
                                                        defaultValue={documentCountryName}
                                                        options={countryCodeArr}
                                                    />
                                                </div>

                                                <div className='col-md-6 px-0  ps-md-2'>
                                                    <SelectInputState
                                                        labelName={'State'}
                                                        defaultValue={documentStateName}
                                                        onChange={(e) => handleDocumentStateName(e)}
                                                        options={stateArr}
                                                    />
                                                </div>
                                            </div>
                                        }

                                        {fileSizeLimitErr &&
                                            <div className='my-1'>
                                                <span className='text-danger fs-6 font-w600'>{`File size should not exceed 20 MB`}</span>
                                            </div>
                                        }

                                        {isDocumentErr &&
                                            <div className='my-1'>
                                                <span className='text-danger fs-6 font-w600'>{`Please select file to uplaod your document`}</span>
                                            </div>
                                        }

                                        <div className='row mx-0 mt-3'>
                                            <div className='col-12 px-0'>
                                                <PrimaryButton
                                                    onClick={() => {
                                                        uploadProfessionalDocumentFn()
                                                    }}
                                                    buttonName={"SUBMIT"}
                                                    type="submit"
                                                    loadingMessage="SAVING..."
                                                    isLoading={updateDocumentsLoading}
                                                    style={{
                                                        width: '100%',
                                                        background: 'linear-gradient(142.98deg, #FF7401 1.99%, #FFA800 99.97%)',
                                                        border: '2px solid rgba(255, 154, 32, 1)',
                                                        boxShadow: '0px 6px 12px 0px rgba(255, 154, 32, 0.24)',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </>
                                }
                            </>
                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            {/* Modal for delete document */}
            <Modal className='fade' centered show={deleteDocumentModalTrigger}>
                <Modal.Body>
                    <div className='row mx-0'>
                        <div className='col-12 px-0'>
                            <>
                                <div className='mx-0 row text-black mb-4'>
                                    <div className='col-11 font-w600 fs-3 px-0 text-center'>
                                        <span>
                                            {"Delete documents"}
                                        </span>
                                    </div>
                                    <div className='col-1 d-flex fs-4 justify-content-end px-0'>
                                        <span onClick={() => handleCloseDeleteDocumentModal()} className='cursor-pointer fs-4 text-black text-hovered'>
                                            <i className="bi bi-x-lg"></i>
                                        </span>
                                    </div>
                                </div>

                                <div className='mx-0 row mb-4'>
                                    <div className='col-12 font-w500 fs-5 px-0 text-center'>
                                        <span>
                                            {`Are you sure you want to delete this ${documentObject?.document_type_int == 1 ? "identity" :
                                                documentObject?.document_type_int == 2 ? "certificate" :
                                                    documentObject?.document_type_int == 3 ? "address" :
                                                        documentObject?.document_type_int == 4 ? "insurance" : "other"} document?`}
                                        </span>
                                    </div>

                                </div>



                                <div className='row mx-0 mt-2'>
                                    <div className='col-12 px-0'>
                                        <PrimaryButton
                                            onClick={() => {
                                                // uploadProfessionalDocuments()
                                                delelteDocumentByIdFn()
                                            }}
                                            buttonName={"DELETE"}
                                            type="submit"
                                            loadingMessage="DELETING..."
                                            isLoading={updateDocumentsLoading}
                                            style={{
                                                width: "100%",
                                                background: 'linear-gradient(142.98deg, #E02D2D 1.99%, #FF5C5C 99.97%)',
                                                boxShadow: '0px 6px 12px 0px rgba(240, 72, 72, 0.24)',
                                                border: '1px solid rgba(240, 72, 72, 1)',
                                            }}
                                        />
                                    </div>
                                </div>
                            </>

                        </div>
                    </div>
                </Modal.Body>
            </Modal >

            {/* Modal for previewing the attached pdf */}
            <>
                <Modal show={openDoc && false} onHide={handleCloseDoc} centered >
                    <div className=''>

                        <div onClick={handleCloseDoc}
                            className=''
                            style={{
                                position: 'fixed',
                                top: '20px',
                                right: "20px",
                                zIndex: 9999,
                            }}
                        >
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>
                    <iframe
                        // src="https://chilllblob.blob.core.windows.net/dev/users/user_177/professional_43/documents/type_1/service_994d38d555df42c1a35d11a816c3cf25_purchase_list (1).pdf"
                        title='Doc'
                        src="https://www.chicagofaucets.com/sites/default/files/spec-sheets/faucets/445-ABCP.pdf"
                        frameborder="0"
                        allow="clipboard-write"
                        webkitallowfullscreen="true"
                        mozallowfullscreen="true"
                        allowfullscreen
                        style={{
                            position: 'fixed',
                            top: '50%',
                            left: "50%",
                            transform: 'translate(-50%, -50%)',
                            width: '70vw',
                            height: '90vh',
                            // zIndex: 9999,
                        }}
                    ></iframe>
                </Modal>
            </>


            {/* Modal for previewing the attached image preview */}
            <>
                <Modal show={openDoc} onHide={handleCloseDoc} centered style={{ background: '#fff0', border: 'none', }}>

                    <div className='image-preview-modal-header'>

                        <a href={imageAttachURL} target="_blank" rel="noreferrer">
                            <i style={{ fontSize: '20px', marginLeft: '20px' }} className="bi bi-download image-preview-modal-action-btn" />
                        </a>

                        <div onClick={handleCloseDoc} className='image-preview-modal-action-btn-close'>
                            <i style={{ fontSize: '30px', }} className="bi bi-x"></i>
                        </div>

                    </div>

                    <>
                        <img src={imageAttachURL} alt='document' style={{ width: '100%', height: '100%' }} />
                    </>

                </Modal>
            </>

            {handleToaster && <ResponceToaster toasterType={toasterType} message={responceMsg} />}
            {/* {apiResponce && !adminTrigger && <ResponceForAPI show={apiResponce} />} */}

        </>
    )
}

export default UploadDocumentsCopy